module.exports = __webpack_public_path__ + "static/media/The Road to learn React.83694f81.pdf";